import React, { Component } from 'react';
import { useImage } from 'react-image'
import {imagePath} from '../common'
export function BussinessComponent(props) {
	const { src } = useImage({
		srcList:imagePath+props.item.image
	})
	return (
        <div className="elemSec">
        <div className="container">
            <div className="elemWrapper">
                <div className="elemItem">
                    <div className="row elemRow">
                        <div className="elemColumn col-12 col-sm-6">
                            <div className="elemImage">
                                <div className="imageGrowWithScaleLeft">
                                    <a className href="javascript:void(0)">
                                        <img src={src} alt="Awesome" />
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="elemColumn col-12 col-sm-6">
                            <div className="elemCont">
                                <h2>{props.item.title}</h2>
                                <h4 className="elemeHeading">{props.item.bussiness_content}</h4>
                                <div className="elemButton">
                                    <a className="hvr-outline-out button2" onClick={() => this.redirect_page(props.item.title)} onClick={()=>{props.onClick(props.item.title)}}>{props.item.button}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
	)
}